import $ from "jquery";

/*
 * Card Funding Data Service -
 * Wrapper for card funding data calls
 */
function executeCall(method, url, payload) {
    var csrfToken = $("[name='__RequestVerificationToken']").val();

    if (typeof (payload) === "object") {
        payload["__RequestVerificationToken"] = csrfToken;
    }

    var executionPromise = new Promise(
        function (resolve, reject) {
            $.ajax({
                type: method,
                url: url,
                data: payload,
                dataType: 'json',
                contentType: 'application/x-www-form-urlencoded; charset=utf-8',
                success: function (data) {
                    return resolve(data);
                },
                error: function (jqXhr, textStatus, errorThrown) {
                    var data = JSON.parse(jqXhr.responseText);
                    return reject(data);
                }
            });
        }
    );

    return executionPromise;
}

class CardFundingDataService {
    constructor() {
    }

    // Public Methods
    processFundingToken(fundingToken) {
        return executeCall("POST", "/funding/card/process", { fundingToken: fundingToken });
    }
}

const dataService = new CardFundingDataService();
export default dataService;